/**
 * @generated SignedSource<<ea00918952f9c081a72af3698e6b7313>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentDeleted_charge$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly taxID: {
      readonly taxID: string | null | undefined;
    } | null | undefined;
  };
  readonly identifier: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkAdditionalInfo_charge" | "PaymentLinkDeletedValue_charge">;
  readonly " $fragmentType": "PaymentDeleted_charge";
} | null | undefined;
export type PaymentDeleted_charge$key = {
  readonly " $data"?: PaymentDeleted_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentDeleted_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentDeleted_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaxID",
            "kind": "LinkedField",
            "name": "taxID",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxID",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "LOG"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkDeletedValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "245fee89b6eb139103eb52eaa08f88e6";

export default node;
